import { createContext } from 'react';

const categoriasRRHHContext = createContext();

export default categoriasRRHHContext;